import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
  getVarsomeHost,
  getRefGenome,
} from "../../../../state/selectors/general.selectors";

function PositionLink({ chr, x0, x1 }) {
  const varsomeHost = useSelector(getVarsomeHost);
  const refGenome = useSelector(getRefGenome);

  const url = useMemo(() => {
    const start = Math.min(x0, x1);
    const end = Math.max(x0, x1);
    return `${varsomeHost}/position/${refGenome}/${chr}:${start}..${end}`;
  }, [chr, x0, x1, varsomeHost, refGenome]);

  if (!chr || x0 === null || x1 === null) {
    return "-";
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-tooltip="Open in VarSome"
    >
      {chr}:&#8203;{x0.toLocaleString()}&#8203;..&#8203;{x1.toLocaleString()}
    </a>
  );
}

PositionLink.propTypes = {
  chr: PropTypes.string,
  x0: PropTypes.number,
  x1: PropTypes.number,
};

PositionLink.defaultProps = {
  chr: null,
  x0: null,
  x1: null,
};

export default PositionLink;
